/* import __COLOCATED_TEMPLATE__ from './seller-postings-sidebar.hbs'; */
import Component from '@glimmer/component';

class SellerPostingsSidebar extends Component {
  get postingUrl() {
    const { selectedItem } = this.args;
    return selectedItem ? `/posting/${selectedItem.idWithSlug}` : undefined;
  }

  constructor() {
    super(...arguments);
    document.body.addEventListener('keydown', this.closeSidebar);
  }

  willDestroy() {
    super.willDestroy();
    document.body.removeEventListener('keydown', this.closeSidebar);
  }

  /**
   * @param {KeyboardEvent} e
   * @private
   */
  closeSidebar = (e) => {
    if (e.key === 'Escape') {
      this.args.close();
    }
  };
}

export default SellerPostingsSidebar;
